import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { premiumGuard } from './guards/premium.guard';
import { homeRedirectGuard } from './guards/home-redirect.guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth']);

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard, homeRedirectGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [], // Empty children required for guard to run
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthPageModule),
  },
  {
    // Gallery is FREE for all authenticated users - no premium guard
    path: 'gallery',
    loadChildren: () => import('./pages/gallery/gallery.module').then(m => m.GalleryPageModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'coral-list',
    loadChildren: () => import('./pages/coral-list/coral-list.module').then( m => m.CoralListPageModule),
    canActivate: [AuthGuard, premiumGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    // coral-view is PUBLIC to allow sharing coral pages with non-logged-in users
    // The page handles shared vs non-shared views internally via query params
    path: 'coral-view',
    loadChildren: () => import('./pages/coral-view/coral-view.module').then( m => m.CoralViewPageModule),
  },
  {
    path: 'timeline',
    loadChildren: () => import('./pages/timeline/timeline.module').then(m => m.TimelinePageModule),
    canActivate: [AuthGuard, premiumGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    // Settings is FREE for all authenticated users - no premium guard
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    // Reminders is FREE for all authenticated users - no premium guard
    path: 'reminders',
    loadChildren: () => import('./pages/reminders/reminders.module').then( m => m.RemindersPageModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'parameters',
    loadChildren: () => import('./pages/parameters/parameters.module').then( m => m.ParametersPageModule),
    canActivate: [AuthGuard, premiumGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'coral-parameters',
    loadChildren: () => import('./pages/coral-parameters/coral-parameters.module').then( m => m.CoralParametersPageModule),
    canActivate: [AuthGuard, premiumGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'subscription',
    loadComponent: () => import('./pages/subscription/subscription.page').then( m => m.SubscriptionPage),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'delete-account',
    loadComponent: () => import('./pages/delete-account/delete-account.page').then( m => m.DeleteAccountPage),
    // Public route - no auth guard needed for Google Play Store compliance
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
